export const MONITORING_HORIZONTAL_MARGIN = '10%';

export const MONITORING_HEADER_CONTAINER_SX = {
    px: MONITORING_HORIZONTAL_MARGIN,
    boxSizing: 'border-box',
};

export const MONITORING_CONTENT_CONTAINER_SX = {
    py: 2,
    px: MONITORING_HORIZONTAL_MARGIN,
    boxSizing: 'border-box',
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
};
